import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-23236420"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-container component--buy-form elevated-box elevation-4 pa-3 pa-sm-6 pa-md-8" }
const _hoisted_2 = { key: 2 }

import { ref, inject, computed, onMounted } from "vue";
import { storeToRefs } from "pinia";

import MewTabs from "../MewTabs/MewTabs.vue";
import BuyForm from "./BuyForm.vue";
import BuyProviders from "./BuyProviders.vue";
import TokenSelect from "./components/TokenSelect.vue";
import SellForm from "./SellForm.vue";

import { Networks } from "./network/networks";
import { useGlobalStore } from "@/plugins/globalStore";
import { defaultCrypto, defaultFiat } from "./handler/defaults";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderForm',
  setup(__props) {

const amplitude: any = inject("$amplitude");

const {
  setSelectedCrypto,
  setSelectedFiat,
  setSelectedNetwork,
  toggleBuyProviders,
  toggleTokenModal,
  setCgPrice,
  setExchangeRates,
} = useGlobalStore();

const { isTokenModalOpen, isBuyProvidersOpen } = storeToRefs(useGlobalStore());

// data
const tabItems = ["Buy", "Sell"];
const activeTab = ref(0);
const step = ref(0);
const locAddress = ref("");

// mounted
onMounted(() => {
  prices();
  exchangeRates();
});

// computed
const isSell = computed(() => {
  return activeTab.value === 1;
});

// methods
const close = () => {
  if (isTokenModalOpen.value) {
    toggleTokenModal();
  }
  if (isBuyProvidersOpen.value) {
    toggleBuyProviders();
  }
};

const reset = () => {
  setSelectedCrypto(defaultCrypto);
  setSelectedFiat(defaultFiat);
  setSelectedNetwork(Networks[0]);
  close();
};

const holdAddress = (address: string) => {
  locAddress.value = address;
};

const onTab = (tab: number) => {
  activeTab.value = tab;
  step.value = 1;
  amplitude.track(`CCBuySell${tab === 0 ? "BuyTab" : "SellTab"}`);
};

const exchangeRates = async () => {
  const ratesFetch = await fetch(
    "https://mainnet.mewwallet.dev/v2/prices/exchange-rates"
  );
  const rates = await ratesFetch.json();
  setExchangeRates(rates);
};

const prices = async () => {
  const tokensFetch = await fetch("https://api-v3.ethvm.dev/", {
    method: "POST",
    headers: {
      accept: "application/json",
      "content-type": "application/json",
    },
    body: '{"operationName":null,"variables":{},"query":"{\\n  getCoinGeckoTokenPriceAll {\\n    id\\n    usd\\n    last_updated_iso8601\\n  }\\n}\\n"}',
  });
  const tokens = await tokensFetch.json();
  setCgPrice(tokens.data.getCoinGeckoTokenPriceAll);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isTokenModalOpen))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([_unref(isTokenModalOpen) ? 'open' : '', 'token-select-slider'])
        }, [
          _createVNode(TokenSelect, {
            class: "pa-3 pa-sm-6 pa-md-8",
            "is-sell": isSell.value,
            onClose: close
          }, null, 8, ["is-sell"])
        ], 2))
      : (_unref(isBuyProvidersOpen))
        ? (_openBlock(), _createBlock(BuyProviders, {
            key: 1,
            onClose: close,
            onReset: reset
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(MewTabs, {
              items: tabItems,
              "active-tab": activeTab.value,
              "base-color": "greenPrimary",
              "has-underline": "",
              onOnTab: onTab
            }, {
              tabContent1: _withCtx(() => [
                _createVNode(BuyForm, {
                  onAddressInput: holdAddress,
                  "held-address": locAddress.value
                }, null, 8, ["held-address"])
              ]),
              tabContent2: _withCtx(() => [
                _createVNode(SellForm, {
                  onAddressInput: holdAddress,
                  "held-address": locAddress.value
                }, null, 8, ["held-address"])
              ]),
              _: 1
            }, 8, ["active-tab"])
          ]))
  ]))
}
}

})